// extracted by mini-css-extract-plugin
module.exports = {"container":"top-panel-module--container--rJdCs","text":"top-panel-module--text--3UAne","appointment":"top-panel-module--appointment--3hvIn"};